import React from "react";
/* eslint-disable */
import {
    Box, Card, Grid, CardContent, Divider, CardHeader,
    TableBody, TableCell, TableContainer, TableHead, TableRow, Table, TableFooter
} from '@material-ui/core';


export default class ComponentToPrint extends React.Component {

    render() {
        const finalData = this.props.finalData;
        const monthList = this.props.monthList;
        const weekCount = this.props.weekCount;
        const year = this.props.year;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;
        const allTotalRow = this.props.allTotalRow;

        return (
            <div>
                <h3><center><u>View Crop Forcast | FAPS</u></center></h3>
                <div>&nbsp;</div>
                <h4><center>Group - {searchData.groupName}</center></h4>
                <h4><center>FreshCollection Center - {searchData.factoryName === undefined ? "All Fresh Collection Centers" : searchData.factoryName}</center></h4>
                <h4><center>Crop - {searchData.productName === undefined ? "All products" : searchData.productName}</center></h4>
                <div>&nbsp;</div>
                <div>
                    <Box p={2}>
                        <Table size="small" border='1px'>
                            <TableHead>
                                <TableRow sx={{ border: "2px solid black" }} >
                                    <TableCell align='center' colSpan={2} sx={{ fontWeight: "bold" }} > Year - {year}</TableCell>
                                    {monthList.map((item) => {
                                        var found = weekCount.filter(x => x.WeekEndDate.substring(0, 3) == item.monthlist.substring(0, 3))
                                        if (found.length != 0) {
                                            return (
                                                <TableCell sx={{ fontWeight: "bold" }} colSpan={found.length} align='center'>{item.monthlist}</TableCell>
                                            )
                                        }
                                    })}
                                    <TableCell align='center' rowSpan={3} sx={{ fontWeight: "bold" }}> Total</TableCell>
                                </TableRow>
                                <TableRow sx={{ border: "2px solid black" }} >
                                    <TableCell sx={{ fontWeight: "bold" }} align='center' rowSpan={2}>Fresh Collection Center</TableCell>
                                    <TableCell sx={{ fontWeight: "bold" }} align='center' rowSpan={2}>Crop</TableCell>
                                    {weekCount.map((item) => (
                                        <TableCell sx={{ fontWeight: "bold" }} colSpan={1} align='center'>Week - {item.weekCount}</TableCell>
                                    ))}
                                </TableRow>
                                <TableRow sx={{ border: "2px solid black" }} >
                                    {weekCount.map((item) => (
                                        <TableCell sx={{ fontWeight: "bold" }} colSpan={1} align='center'>{item.WeekStartDate} - {item.WeekEndDate}</TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {finalData.map((row) => (
                                    <TableRow sx={{ border: "2px solid black" }} key={row.Farmer}>
                                        <TableCell align='center'> {row.factoryName}</TableCell>
                                        <TableCell align='center'> {row.productName}</TableCell>
                                        {weekCount.map((column) => {
                                            const value = row[column.weekCount];
                                            return (
                                                <TableCell align='center'>{value == undefined ? '-' : value == 0 ? '-' : parseInt(value) + ' Kg'}</TableCell>
                                            );
                                        })}
                                        <TableCell style={{ width: 100, fontWeight: "bold" }} align='right'>{allTotalRow == undefined ? '-' : allTotalRow == 0 ? '-' : parseInt(allTotalRow) + ' Kg'}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow sx={{ border: "2px solid black" }}>
                                    <TableCell align='center' style={{ fontWeight: "bold" }} colSpan={2}> Total</TableCell>
                                    {weekCount.map((column) => {
                                        const found = totalRow.find(x => x.name == column.weekCount);
                                        return (
                                            <TableCell style={{ width: 100, fontWeight: "bold" }} align='right'>{found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value) + ' Kg'}</TableCell>
                                        );
                                    })}
                                    <TableCell style={{ width: 100, fontWeight: "bold" }} align='right'>{allTotalRow == undefined ? '-' : allTotalRow == 0 ? '-' : parseInt(allTotalRow) + ' Kg'}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                </div>
            </div>

        );
    }
}
